<template>
  <div>
    <!--彈出視窗-->
    <v-dialog v-model="visible" persistent :max-width="width">
      <v-card>
        <v-card-title class="headline">
          {{ title }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-select
                label="類型"
                :items="typeList"
                item-text="text"
                item-value="key"
                v-model="type"
                @change="changeTypeStatus()"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-select
                label="商品名稱"
                :items="productList"
                item-text="text"
                item-value="key"
                v-model="editedItem.productId"
              ></v-select>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12>
              <v-radio-group
                v-model="radioGroup"
                row>
                <v-radio
                  label="單一編號"
                  value="0"
                ></v-radio>
                <v-radio
                  label="多組編號"
                  value="1"
                ></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 v-if="isNew">
              <span style="color: red" v-if="radioGroup === `1`">請填寫範圍在{{startNumber+99}}以內的數字</span>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-text-field v-model="startNumber" readonly></v-text-field>
                  </v-flex>
                  <v-flex xs6 v-if="radioGroup === `1`">
                    <v-text-field v-model="endNumber"></v-text-field>
                  </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 v-else>
              <v-text-field v-model="editedItem.productNumber" readonly></v-text-field>
            </v-flex>
          </v-layout>

          <!-- <v-layout row wrap>
            <v-flex xs12>
              <v-select
                label="版本"
                :items="categoryList"
                item-text="text"
                item-value="key"
                v-model="editedItem.category"
              ></v-select>
            </v-flex>
          </v-layout> -->

           <v-layout v-if="!isNew" row wrap>
            <v-flex xs12>
              <v-select
                label="狀態"
                :items="statusKey"
                item-text="text"
                item-value="key"
                v-model="editedItem.status"
              ></v-select>
            </v-flex>
          </v-layout>
          
          <!-- <v-layout row wrap>
            <v-flex xs12>
              <v-select
                label="數量"
                :items="quantitylist"
                item-text="value"
                item-value="key"
                v-model="editedItem.count"
              ></v-select>
            </v-flex>
          </v-layout> -->
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                :label="`單價`"
                background-color="#49bcfd"
                outline
                v-model="editedItem.price"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex>
              <v-text-field
                :label="`備註`"
                background-color="#49bcfd"
                outline
                v-model="editedItem.commit"
              ></v-text-field>
            </v-flex>
          </v-layout>


          <!-- <v-layout row wrap>
            <v-flex>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="editedItem.makeDate"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="editedItem.makeDate"
                    label="製造日期"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="editedItem.makeDate"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    dark
                    text
                    color="red"
                    @click="menu = false"
                  >
                    取消
                  </v-btn>
                  <v-btn
                    dark
                    text
                    color="primary"
                    @click="$refs.menu.save(editedItem.makeDate)"
                  >
                    確定
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout> -->


        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark text @click="cancelEvent">取消</v-btn>
          <v-btn color="primary" dark text @click="confirmEvent">確定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MobileDetect from "mobile-detect";
import { mapActions } from "vuex";

const md = new MobileDetect(window.navigator.userAgent);

export default {
  name: "StockEditDialog",
  props: {
    visible: Boolean,
    title: String,
    categoryList: Array,
    typeList: Array,
    productList:Array,
    statusKey:Array,
    item: Object,
    isNew:Boolean,
  },
  data() {
    return {
      width: md.phone() ? "80%" : "50%",
      type: 0,
      quantitylist: [],
      itemList:[],
      menu: false,
      startNumber: 0,
      endNumber:0,
      radioGroup:0
    };
  },
  created() {
    this.sortlist();
    this.loadProductId();
  },
  computed: {
    editedItem() {
      return this.item;
    },
  },
  watch: {
    visible(value) {
      if (value){
        this.sortlist();
        this.loadProductId();
        this.radioGroup = 0;
        this.endNumber = 0;
      }
    }
  },
  methods: {
    ...mapActions([
      "getProductId",
    ]),

    sortlist() {
      for (let i = 1; i <= 100; i++) {
        this.quantitylist.push({ key: i, value: `${i}` });
      }
      return this.quantitylist;
    },
    changeTypeStatus(){
      this.loadProductId();
    },
    async loadProductId(){
      const results = await this.getProductId({type:this.type});
      this.startNumber = results.data.data.number;
      this.startNumber++;
    },
    confirmEvent() {
      this.editedItem.count = this.editedItem.count > 0 ? this.editedItem.count : 1;
      if (this.checkData()) {
        console.log("超過囉")
        return
      }
      if(this.isNew) {
        if(this.radioGroup === `1` ) {
          this.editedItem.productNumber = `${this.startNumber}-${this.endNumber}`;
        } else {
          this.editedItem.productNumber = this.startNumber;
        }
      }

      this.$emit("confirmEvent", this.editedItem);
    },
    checkData(){
      if(!this.isNew || this.radioGroup === `0`) {
        return false;
      }

      if((this.endNumber - this.startNumber ) > 100){
        return true
      } else if ((this.endNumber - this.startNumber ) < 0) {
        return true
      } else {
        return false
      }
    },
    cancelEvent() {
      this.$emit("cancelEvent");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/StockEditDialog.vue